import { useEffect, useMemo, useRef, useState, useCallback } from 'react';
import { getDocsArchive, deleteDoc, toAbsoluteUrl } from '../../api/admin/docs.api';
import './AdminArchive.css';

const kindLabel = (k) => {
  if (k === 'invoice') return 'Счёт';
  if (k === 'sales-act') return 'Реализация';
  if (k === 'order') return 'Заказ клиента';
  return k;
};

export default function AdminArchive() {
  const [q, setQ] = useState('');
  const [kind, setKind] = useState('');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const qRef = useRef(q);
  const kindRef = useRef(kind);
  useEffect(() => { qRef.current = q; }, [q]);
  useEffect(() => { kindRef.current = kind; }, [kind]);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await getDocsArchive({ q: qRef.current, kind: kindRef.current });
      setItems(res?.data || []);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]); // первичная загрузка

  const rows = useMemo(() => items.map(d => ({
    id: d._id,
    title: d.title || kindLabel(d.kind),
    kind: kindLabel(d.kind),
    buyer: d.buyerName || '',
    orderNumber: d.orderNumber || '',
    date: d.createdAt ? new Date(d.createdAt).toLocaleString('ru-RU') : '',
    url: toAbsoluteUrl(d.filePath),
  })), [items]);

  async function onDelete(id) {
    if (!window.confirm('Отменить документ в архиве? (файл сохранится, статус canceled)')) return;
    await deleteDoc(id);
    setItems(prev => prev.filter(x => x._id !== id));
  }

  return (
    <div className="archive">
      <h2 className="admin-page-title">Архив документов</h2>

      <div className="archive-toolbar">
        <input className="fld" placeholder="Поиск (клиент/номер/название)" value={q} onChange={e => setQ(e.target.value)} />
        <select className="fld" value={kind} onChange={e => setKind(e.target.value)}>
          <option value="">Все типы</option>
          <option value="invoice">Счёт</option>
          <option value="sales-act">Реализация</option>
          <option value="order">Заказ клиента</option>
        </select>
        <button className="admin-btn" onClick={load} disabled={loading}>{loading ? '...' : 'Обновить'}</button>
      </div>

      <table className="archive-table">
        <thead>
          <tr>
            <th>Документ</th>
            <th>Тип</th>
            <th>Клиент</th>
            <th>Заказ</th>
            <th>Дата</th>
            <th style={{ width: 220 }}>Действия</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(r => (
            <tr key={r.id}>
              <td>{r.title}</td>
              <td><span className="archive-kind">{r.kind}</span></td>
              <td>{r.buyer}</td>
              <td>{r.orderNumber}</td>
              <td>{r.date}</td>
              <td>
                <div className="archive-actions">
                  <a href={r.url} target="_blank" rel="noreferrer">Открыть</a>
                  <button className="muted" onClick={() => onDelete(r.id)}>Удалить</button>
                </div>
              </td>
            </tr>
          ))}
          {!rows.length && !loading && (
            <tr><td colSpan="6" className="archive-empty">Пусто</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
